export default "__VITE_ASSET__1888207e__"